import { TransformWithLVS } from './TransformWithLVS';
export function Trim(options, transformOptions) {
    return TransformWithLVS(({ value }) => {
        if (typeof value !== 'string') {
            return value;
        }
        switch (options?.strategy) {
            case 'start':
                return value.trimLeft();
            case 'end':
                return value.trimRight();
            default:
                return value.trim();
        }
    }, transformOptions);
}
//# sourceMappingURL=Trim.js.map